import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import Register from './components/Register';
import Login from './components/Login';
import Home from './components/Home';
import Ads from './components/Ads';
import Stats from './components/Stats';
import AdDetails from './components/AdDetails';
import AdPage from './components/AdPage';
import AdminAds from './components/AdminAds';
import Layout from './components/Layout';

// Suppress ResizeObserver loop limit exceeded warning
const resizeObserverLoopErr = /ResizeObserver loop limit exceeded/;

window.addEventListener('error', (event) => {
    if (resizeObserverLoopErr.test(event.message)) {
        event.stopImmediatePropagation();
    }
});

window.addEventListener('unhandledrejection', (event) => {
    if (resizeObserverLoopErr.test(event.reason)) {
        event.stopImmediatePropagation();
    }
});

const App = () => {
    const [openLogin, setOpenLogin] = useState(false);
    const [openRegister, setOpenRegister] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('username'));
    const [username, setUsername] = useState(localStorage.getItem('username') || '');
    const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

    useEffect(() => {
        const storedUsername = localStorage.getItem('username');
        const storedUserId = localStorage.getItem('userId');
        if (storedUsername) {
            setUsername(storedUsername);
        }
        if (storedUserId) {
            setUserId(storedUserId);
        }
    }, []);

    const handleOpenLogin = () => {
        setOpenLogin(true);
    };

    const handleCloseLogin = () => {
        setOpenLogin(false);
    };

    const handleOpenRegister = () => {
        setOpenRegister(true);
    };

    const handleCloseRegister = () => {
        setOpenRegister(false);
    };

    const handleLogin = (user) => {
        localStorage.setItem('username', user.username);
        localStorage.setItem('userId', user.id);
        setIsAuthenticated(true);
        setUsername(user.username);
        setUserId(user.id);
        handleCloseLogin();
    };

    const handleRegister = () => {
        setOpenRegister(false);
        setShowConfirmationPopup(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('username');
        localStorage.removeItem('userId');
        setIsAuthenticated(false);
        setUsername('');
        setUserId('');
    };

    return (
        <Router>
            <Layout
                isAuthenticated={isAuthenticated}
                username={username}
                handleLogout={handleLogout}
                handleOpenLogin={handleOpenLogin}
                handleOpenRegister={handleOpenRegister}
            >
                <Routes>
                    <Route path="/home" element={<Home />} />
                    <Route path="/ads" element={<Ads />} />
                    <Route path="/ads/:id" element={<AdDetails />} />
                    <Route path="/stats" element={<Stats />} />
                    <Route path="/ad-page/:adId" element={<AdPage user={{ id: userId, username: username }} />} />
                    <Route path="/admin/ads" element={<AdminAds />} />
                    <Route path="/" element={<Home />} />
                </Routes>
                <Dialog open={openLogin} onClose={handleCloseLogin}>
                    <DialogTitle>Login</DialogTitle>
                    <DialogContent>
                        <Login onLogin={handleLogin} />
                    </DialogContent>
                </Dialog>
                <Dialog open={openRegister} onClose={handleCloseRegister}>
                    <DialogTitle>Register</DialogTitle>
                    <DialogContent>
                        <Register onRegister={handleRegister} onLogin={handleLogin} />
                    </DialogContent>
                </Dialog>
                {showConfirmationPopup && (
                    <Dialog open={showConfirmationPopup} onClose={() => setShowConfirmationPopup(false)}>
                        <DialogTitle>Registration Successful</DialogTitle>
                        <DialogContent>
                            <Typography>Please check your email to confirm your account.</Typography>
                        </DialogContent>
                    </Dialog>
                )}
            </Layout>
        </Router>
    );
};

export default App;